import React, { Component } from 'react';
import Script from 'react-load-script';
import _debounce from 'lodash.debounce';
import { geocodeByAddress } from 'react-places-autocomplete';

import ManualLocationForm from './ManualLocationForm';
import LabelWrapper from '../../LabelWrapper';
import Link from '../../Link';
import {
  buildAddressStateFromRes,
  isValidAddress,
  getFullAddressFromPartial,
  getCoordinates } from
'../utils/address';
import { MANUAL_LOCATION_LINK, LOCATION_SELECTOR__ROOT } from '../styles/locationSelector';
import LocationSelector from './LocationSelector';
import isEmptyAddress from '../utils/isEmptyAddress';

// Added this comment just in case for future usage of 'loading'
/* eslint-disable react/no-unused-state */






















function focusInput(id, { childInput } = {}) {
  const input = childInput ? document.querySelector(`#${id} input`) : document.getElementById(id);

  if (!input) {return;}

  // Resolves a bug where after the dropdown search is disabled, you cannot refocus until blurred
  input.blur();
  input.focus();
}

export default class LocationSelectorRoot extends Component

{


  static defaultProps = { placeholder: 'Enter location' };

  constructor(props) {
    super(props);

    this.state = {
      addressRepresentation: '',
      address: props.initialAddress || {},
      apiReady: false,
      isManualEntry: !isEmptyAddress(props.initialAddress)
    };

    // Every time the user changes any part of the address we call the parent
    // onSelectAddress to update. Debouncing this makes it more performant.
    this.debouncedOnSelectAddress = _debounce(props.onSelectAddress, 100);
  }

  onScriptLoaded = () => {
    this.setState({ apiReady: true });
  };

  onSelectGoogleAddress = async (address) => {
    if (!address) {return;}

    try {
      this.setState({ loading: true });

      const results = await geocodeByAddress(address);

      const coordinates = await getCoordinates(results[0], false);

      const addressComponents = results[0].address_components;
      const formattedAddress = buildAddressStateFromRes(addressComponents);
      const addressWithCoordinates = { ...formattedAddress, coordinates };

      this.setState({
        address: addressWithCoordinates,
        isManualEntry: true,
        addressRepresentation: '',
        loading: false
      }, () => {
        this.debouncedOnSelectAddress(
          getFullAddressFromPartial(addressWithCoordinates),
          { isValidAddress: isValidAddress(addressWithCoordinates) }
        );

        focusInput('street-address');
      });
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  requestUserLocation = () => {
    const { userLocation } = this.state;

    if (userLocation) {return;}

    // Attempt to get location so we can bias the Google API results
    navigator.geolocation.getCurrentPosition(this.setUserLocation);
  };

  setUserLocation = (location) => {
    if (!location) {return;}

    this.setState({ userLocation: location });
  };

  handleAddressInputChange = (address) => {
    this.setState({ addressRepresentation: address });
  };

  handleToggleForm = () => {
    const { id } = this.props;

    this.setState(
      ({ isManualEntry }) => ({
        isManualEntry: !isManualEntry,
        addressRepresentation: '',
        address: {}
      }),
      () => {
        const { isManualEntry } = this.state;

        this.debouncedOnSelectAddress(
          getFullAddressFromPartial({}),
          { isValidAddress: false }
        );

        // Focus the right input when the form has been toggled
        focusInput(isManualEntry ? 'street-address' : id, { childInput: !isManualEntry });
      }
    );
  };

  handleManualAddressChange = (field) => (
  { target: { value } }) =>
  {
    const { address } = this.state;
    const newAddress = { ...address, [field]: value };

    this.setState({ address: newAddress }, async () => {
      const coordinates = await getCoordinates(newAddress);
      const addressWithCoordinates = { ...newAddress, coordinates };

      this.debouncedOnSelectAddress(
        getFullAddressFromPartial(addressWithCoordinates),
        { isValidAddress: isValidAddress(addressWithCoordinates) }
      );
    });
  };

  render() {
    const { apiReady, addressRepresentation, userLocation, isManualEntry, address } = this.state;
    const {
      placeholder,
      label,
      id,
      disabled,
      labelProps,
      dropdownType,
      renderMenuLocally
    } = this.props;
    return (
      <div className={LOCATION_SELECTOR__ROOT}>
        <Script
          url="https://maps.googleapis.com/maps/api/js?key=AIzaSyDsF3S_T5qytLOSEvdxGGYk6lLvAHH6hXY&libraries=places"
          onLoad={this.onScriptLoaded} />

        <LabelWrapper
          {...labelProps}
          id={id}
          label={label}
          extraLabelContent={
          !disabled ?

          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link button className={MANUAL_LOCATION_LINK} onClick={this.handleToggleForm}>
                  {isManualEntry ? 'Search For Your Address' : 'Enter Address Manually'}
                </Link> :

          null}>


          {
          apiReady ?

          <LocationSelector
            id={id}
            addressString={addressRepresentation}
            onChangeAddress={this.handleAddressInputChange}
            onSelect={this.onSelectGoogleAddress}
            userLocation={userLocation}
            placeholder={placeholder}
            disabled={disabled}
            isManualEntry={isManualEntry}
            requestUserLocation={this.requestUserLocation}
            dropdownType={dropdownType}
            renderMenuLocally={renderMenuLocally} /> :


          null}

        </LabelWrapper>
        {
        isManualEntry ?

        <ManualLocationForm
          address={address}
          onChangeAddressField={this.handleManualAddressChange}
          disabled={disabled} /> :


        null}

      </div>);

  }
}